import { render } from "./messagesGame.vue?vue&type=template&id=ba766586"
import script from "./messagesGame.vue?vue&type=script&lang=js"
export * from "./messagesGame.vue?vue&type=script&lang=js"

import "./messagesGame.vue?vue&type=style&index=0&id=ba766586&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__